import React, { createContext, useContext, useState, useEffect, useRef } from 'react';
import api from '../lib/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [company, setCompany] = useState(null);
  const [loading, setLoading] = useState(true);
  const initializedRef = useRef(false);

  useEffect(() => {
    if (initializedRef.current) return;
    initializedRef.current = true;
    const savedToken = localStorage.getItem('token');
    if (!savedToken) { setLoading(false); return; }
    api.get('/auth/me').then(res => {
      setUser(res.data.user);
      setCompany(res.data.company);
    }).catch(() => {
      localStorage.removeItem('token');
    }).finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const res = await api.post('/auth/login', { email, password });
    const { token: t, user: u, company: c } = res.data;
    localStorage.setItem('token', t);
    setUser(u);
    setCompany(c);
    setLoading(false);
    return res.data;
  };

  const register = async (email, password, name, company_name) => {
    const res = await api.post('/auth/register', { email, password, name, company_name });
    const { token: t, user: u } = res.data;
    localStorage.setItem('token', t);
    setUser(u);
    try {
      const meRes = await api.get('/auth/me');
      setCompany(meRes.data.company);
    } catch {}
    setLoading(false);
    return res.data;
  };

  const logout = () => {
    localStorage.removeItem('token');
    setUser(null);
    setCompany(null);
  };

  const refreshCompany = async () => {
    try {
      const res = await api.get('/auth/me');
      setCompany(res.data.company);
      setUser(res.data.user);
    } catch {}
  };

  return (
    <AuthContext.Provider value={{ user, company, token: localStorage.getItem('token'), loading, login, register, logout, refreshCompany }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
